import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlay, FaGooglePlay, FaApple } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Logo from '../Images/pikchar.png';

const Hero = ({ image, title, genre, rating, id }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleImageLoad = () => {
      setIsLoading(false);
    };

    const img = new Image();
    img.src = image;
    img.onload = handleImageLoad;
  }, [image]);

  return (
    <div className='-z-10'>
      <div className="relative">
        {isLoading ? (
          <div className=' flex flex-col'>
            <Skeleton className=' md:h-[700px] h-[250px] ' baseColor='#3F3F3F' />
          </div>
        ) : (
          <img src={image} alt="main banner" className="w-full" />
        )}
        <div className="absolute inset-0 w-[50%] bg-gradient-to-r from-black to-transparent" />
        <div className="absolute inset-0 w-[50%] bg-gradient-to-r from-black to-transparent" />

        <div className="md:hidden fixed top-0 left-0 z-20 p-2 mt-2 ms-2">
          <a href="/">
            <img src={Logo} alt="Logo" className="w-8 h-8" />
          </a>
        </div>

        {/* ========== DOWNLOAD BUTTONS (Google Play + App Store) ========== */}
        {/* <div className="absolute top-4 right-4 z-20 flex gap-2">
          <a
            href="https://play.google.com/store/apps/details?id=com.gyanesh.mobiletalkies&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on Google Play"
            className="
              bg-gradient-to-r from-[#1D2671] to-[#C33764] 
              text-white py-2 px-4 rounded-lg shadow-lg 
              hover:scale-105 transform transition duration-300 ease-in-out 
              flex items-center
              md:py-3 md:px-5 md:rounded-xl md:text-base
            "
          >
            <FaGooglePlay className="mr-1 text-base md:text-lg md:mr-2" />
            <span className="font-semibold text-xs md:text-sm">Pikchar for Android</span>
          </a>

          <a
            href="https://apps.apple.com/sg/app/pikchar/id6754800532"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
            className="
              bg-gradient-to-r from-[#0f172a] to-[#334155] 
              text-white py-2 px-4 rounded-lg shadow-lg 
              hover:scale-105 transform transition duration-300 ease-in-out 
              flex items-center
              md:py-3 md:px-5 md:rounded-xl md:text-base
            "
          >
            <FaApple className="mr-1 text-base md:text-lg md:mr-2" />
            <span className="font-semibold text-xs md:text-sm">Pikchar for IOS</span>
          </a>
        </div> */}
        {/* =============================================================== */}

        <div className="absolute bottom-0 w-full h-[25%] bg-gradient-to-t from-[#0C0404] to-transparent" />
      </div>

      {/* Desktop / Desktop-large: keep consistent vertical spacing with gap */}
      <div className='pa lg:top-56 top-20 max-md:hidden'>
        <div className="flex flex-col gap-6"> {/* <- consistent spacing */}
          <p className='lg:text-5xl md:text-3xl sm:text-2xl mb-0 font-bold uppercase'>
            {isLoading ? <Skeleton width={300} /> : title}
          </p>

          <div>
            <span className='text-lg font-bold block mb-1'>
              {isLoading ? <Skeleton width={100} /> : genre}
            </span>
            <span className='text-lg font-semibold block'>
              {isLoading ? <Skeleton width={50} /> : rating}
            </span>
          </div>

          <div>
            {isLoading ? (
              <Skeleton width={288} height={48} />
            ) : (
              <Link
                to={`/main-list/${id}`}
                className='
                  bg-[#E50914]                 /* Netflix red */
                  text-white
                  font-semibold text-xl w-72 h-12 rounded-md
                  duration-200 ease-linear transform hover:scale-105 flex justify-center items-center
                  shadow-md
                '
              >
                Watch Now
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* mobile layout - keep consistent spacing between play, title and meta */}
      <div className='bottom-10 left-1/2 transform -translate-x-1/2 flex justify-center items-center flex-col absolute w-full md:hidden'>
        <div className="flex flex-col items-center gap-4"> {/* <- consistent spacing on mobile */}
          {isLoading ? (
            <Skeleton circle={true} width={56} height={56} />
          ) : (
            <Link to={`/main-list/${id}`} className='w-14 h-14 rounded-full border-2 border-white flex items-center justify-center bg-white bg-opacity-15 mb-0'>
              <FaPlay className='opacity-80 text-lg flex items-center justify-center' />
            </Link>
          )}

          <p className='font-semibold text-xs opacity-70'>
            {isLoading ? <Skeleton width={30} /> : rating}
          </p>

          <p className='font-bold text-xl max-[320px]:text-lg text-center'>
            {isLoading ? <Skeleton width={150} /> : title}
          </p>

          <p className='font-semibold text-[10px] opacity-50'>
            {isLoading ? <Skeleton width={100} /> : genre}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;
